export default __webpack_public_path__ + "static/media/IMG_0358 copie.db5104c9.jpg";